import React, { useRef, useState } from 'react';
import buzLogo from '../assets/images/amazon.png';

function TrustedBy() {
  const scrollerRef = useRef(null);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const brands = [
    { name: "Lewis", logo: buzLogo },
    { name: "Karen Millen", logo: buzLogo },
    { name: "Kiko Milano", logo: buzLogo },
    { name: "Kohls", logo: buzLogo },
    { name: "Kappa", logo: buzLogo },
    { name: "Kohls 2", logo: buzLogo },
    { name: "Canon", logo: buzLogo },
    { name: "Amazon", logo: buzLogo },
    { name: "Salesforce", logo: buzLogo },
    { name: "Karl Lagerfeld", logo: buzLogo }
  ];

  // Mouse events
  const handleMouseDown = (e) => {
    setIsMouseDown(true);
    setStartX(e.pageX - scrollerRef.current.offsetLeft);
    setScrollLeft(scrollerRef.current.scrollLeft);
  };

  const handleMouseUp = () => {
    setIsMouseDown(false);
  };

  const handleMouseLeave = () => {
    setIsMouseDown(false);
  };

  const handleMouseMove = (e) => {
    if (!isMouseDown) return;
    e.preventDefault();
    const x = e.pageX - scrollerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollerRef.current.scrollLeft = scrollLeft - walk;
  };

  // Touch events
  const handleTouchStart = (e) => {
    setIsMouseDown(true);
    setStartX(e.touches[0].pageX - scrollerRef.current.offsetLeft);
    setScrollLeft(scrollerRef.current.scrollLeft);
  };

  const handleTouchEnd = () => {
    setIsMouseDown(false);
  };

  const handleTouchMove = (e) => {
    if (!isMouseDown) return;
    const x = e.touches[0].pageX - scrollerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <section className="py-12 px-4 bg-white overflow-hidden hidden">
      <div className="container mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 tracking-wide">
          TRUSTED BY 500+ BUSINESSES
        </h2>

        <div
          className="relative w-full overflow-hidden"
          style={{ cursor: isMouseDown ? "grabbing" : "grab" }}
        >
          <div
            ref={scrollerRef}
            className="flex items-center gap-8 md:gap-12 whitespace-nowrap overflow-x-auto scrollbar-hide scroll-smooth"
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
          >
            {brands.map((brand, index) => (
              <div
                key={index}
                className="w-24 h-12 flex-shrink-0 flex items-center justify-center"
              >
                <img
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="max-w-full max-h-full object-contain opacity-80 hover:opacity-100 transition-opacity"
                  draggable="false"
                />
              </div>
            ))}
          </div>
        </div>

        {/* <div className="mt-8 text-center">
          <a
            href="#partners"
            className="inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors"
          >
            <span className="font-medium">View all our partners</span>
            <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
          </a>
        </div> */}
      </div>
    </section>
  );
}

export default TrustedBy;
